import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-rating-diagram',
    styleUrl: 'zr-rating-diagram.scss',
    shadow: true,
})

/**
 * ZooRoyal ratings component.
 */
export class ZrRatingDiagram {
    /**
     * The rating stars level (1 to 5).
     */
    @Prop() points: string

    /**
     * The average rating percentage-value per star-level.
     */
    @Prop() percentage: string

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-rating__diagram">
                    <span class="zr-rating__diagram-level">{this.points}</span>
                    <meter class="zr-rating__diagram-meter" min="0" max="100" value={this.percentage}>
                        {this.percentage}
                    </meter>
                    <span class="zr-rating__diagram-meter-label">{this.percentage}&nbsp;%</span>
                </div>
            </Host>
        )
    }
}
